import React, { useEffect, useState } from "react";
import "./style2.css";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import Spinner from "../../components/LoadingSpinner/loadingSpinner";
import api from "../../api";

const baseUrl = process.env.REACT_APP_BASE_URL;

const OfferModal = ({
  show,
  onClose,
  title = "",
  name = "",
  description = "",
  service = "",
  date_end = "",
  offerId,
  reward,
  onOfferTaken,
}) => {
  const [languageData, setLanguageData] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;

    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/offerModal/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);
  const formatTime = (seconds) => {
    const sec = Number(seconds);

    if (isNaN(sec) || sec < 0) return "0 second";

    const hours = Math.floor(sec / 3600);
    const minutes = Math.floor((sec % 3600) / 60);
    const secs = sec % 60;

    const parts = [];

    if (hours > 0) {
      parts.push(
        `${hours} ${hours === 1 ? languageData.hour : languageData.hours}`,
      );
    }

    if (minutes > 0) {
      parts.push(
        `${minutes} ${minutes === 1 ? languageData.minute : languageData.minutes}`,
      );
    }

    if (secs > 0 || parts.length === 0) {
      parts.push(
        `${secs} ${secs === 1 ? languageData.second : languageData.seconds}`,
      );
    }

    return parts.join(" ");
  };

  const handleTakeOffer = async () => {
    try {
      setLoading(true);

      const res = await api.post("/services/take-introductory-offer", {
        offer_id: offerId,
      });

      const responseData = res?.data?.data;

      const programId = responseData?.program_id;
      const isWithProgram = !!programId;
      const rewards = responseData?.rewards || [];
      const addedCredits = responseData?.added_credits || [];

      const currencyMap = {
        EUR: "€",
        USD: "$",
        GBP: "£",
      };

      const rewardsHtml = rewards
        .map((reward) => {
          if (reward.type === "points") {
            return `
            <div class="mb-10">
              • <strong>+${reward.points} points</strong>
            </div>
          `;
          }

          if (reward.type === "discount") {
            const packageNames = (reward.packages || [])
              .map((pkg) => pkg.name)
              .join(", ");

            return `
            <div class="mb-10">
              • <strong>${parseFloat(
                reward.discounts?.value,
              )}% ${languageData.discount}</strong>
              <br/>
              ${packageNames}
              <br/>
              ${languageData.instead_of}
              <s>
                ${reward.price}${currencyMap[reward.currency]}
              </s>
              ,
              ${languageData.pay_just}
              <strong>
                ${reward.discounted_price}${currencyMap[reward.currency]}
              </strong>
            </div>
          `;
          }

          if (reward.type === "package" || reward.type === "free_product") {
            const packages = (reward.packages || [])
              .map((pkg) => {
                const items = (pkg.items || [])
                  .map((item) => {
                    const value =
                      item.unit === "period"
                        ? formatTime(item.size)
                        : item.size;

                    const label =
                      item.service.communication === "call"
                        ? languageData.duration
                        : item.service.communication === "email"
                          ? "emails"
                          : "messages";

                    return `• ${value} ${label}`;
                  })
                  .join("<br>");

                return `
                <div class="mb-10">
                  <strong>${pkg.name}</strong>
                  <br/>
                  ${items}
                </div>
              `;
              })
              .join("");

            return packages;
          }

          return "";
        })
        .join("");

      if (isWithProgram) {
        setLoading(false);
        const result = await Swal.fire({
          icon: "success",
          title: languageData.alert.success.title,
          html: rewardsHtml,
          confirmButtonText: languageData.go_to_payment,
        });

        if (result.isConfirmed) {
          const orderRes = await api.post("/invoicing/orders/create", {
            source_id: programId,
            source_type: "loyalty_program",
          });

          const paymentLink = orderRes?.data?.data?.payment_link;

          onClose();

          if (paymentLink) {
            const width = 800;
            const height = 900;
            const left = window.screenX + (window.outerWidth - width) / 2;
            const top = window.screenY + (window.outerHeight - height) / 2;

            window.open(
              paymentLink,
              "PaymentWindow",
              `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
            );
          }
          window.dispatchEvent(new Event("refresh-dashboard"));
          window.dispatchEvent(new Event("refresh-header"));
          await onOfferTaken?.();
          onClose();
        }
      } else if (addedCredits.length > 0) {
        const creditsHtml = addedCredits
          .map((credit) => {
            if (
              credit.unit === "period" &&
              credit.communication_type === "call"
            ) {
              return `
              <li class="flex align-items-center justify-content-center gap-1 mb-2">
                ${formatTime(credit.credit)} <strong>${credit.package?.name}</strong>              </li>
            `;
            }

            if (credit.communication_type === "email") {
              return `
              <li class="flex align-items-center justify-content-center gap-1">${credit.credit} emails <strong>${credit.package?.name}</strong></li>
            `;
            }

            if (credit.communication_type === "chat") {
              return `
              <li class="flex align-items-center justify-content-center gap-1">${credit.credit} messages <strong>${credit.package?.name}</strong></li>
            `;
            }

            return "";
          })
          .join("");
        setLoading(false);
        const result = await Swal.fire({
          icon: "success",
          title: languageData.alert.success.title,
          html: `
      <p class=" fs-16">${languageData.alert.success.description}</p>
      <ul class="font-16 flex flex-column align-items-center justify-content-center">
        ${creditsHtml}
      </ul>
    `,
          confirmButtonText: "OK",
        });

        if (result.isConfirmed) {
          window.dispatchEvent(new Event("refresh-dashboard"));
          window.dispatchEvent(new Event("refresh-header"));
          await onOfferTaken?.();
          onClose();
        }
      }
    } catch (err) {
      console.error(err);

      Swal.fire({
        icon: "error",
        title: languageData.alert.error.title,
        text: languageData.alert.error.description,
      });
    } finally {
      setLoading(false);
    }
  };
  if (!languageData) {
    return <div></div>;
  }
  const rewardType = reward?.reward_type;

  const imageByType = {
    free_product: "../../assets/images/free_product.png",
    package: "../../assets/images/package.png",
  };

  const formatTitle = (title = "") => {
    const [firstWord, ...rest] = title.trim().split(" ");
    return {
      firstWord,
      rest: rest.join(" "),
    };
  };
  const { firstWord, rest } = formatTitle(title);

  return (
    <div>
      <Modal
        show={show}
        onHide={onClose}
        centered
        dialogClassName="IntroductoryOffer custom-modal-dialog"
      >
        <div class="OfferContent">
          <div class="flex w-100">
            <div class="flex flex-column justify-content-center align-items-center w-50">
              <h2 class="u-text-2 Name_offer">
                {" "}
                {firstWord} {rest && <span>{rest}</span>}
              </h2>
              <p class="service_name text-center">{description}</p>

              {reward?.map((reward, rewardIndex) => {
                const rewardType = reward?.reward_type;

                return (
                  rewardType === "discount" && (
                    <h2 className="discount">
                      -{reward?.discounts?.value ?? ""}
                    </h2>
                  )
                );
              })}
              {reward?.map((reward, rewardIndex) => {
                const rewardType = reward?.reward_type;

                return (
                  (rewardType === "free_product" ||
                    rewardType === "package") && (
                    <div key={rewardIndex} className="u-group-1">
                     {rewardType === "free_product" && (
          <div className={`pulse ${rewardType}`}>
            <svg
              viewBox="0 0 500 500"
              xmlns="http://www.w3.org/2000/svg"
              className="pulse"
              width="52px"
            >
              <defs>
                <radialGradient id="sunburst" cx="50%" cy="50%" r="50%">
                  <stop offset="0%" stopColor="#ffce44" />
                  <stop offset="100%" stopColor="#ff911a" />
                </radialGradient>
              </defs>

              <path
                d="M250,50 L280,120 L350,80 L340,160 L420,150 L380,220 L450,270 L370,300 L400,380 L320,350 L280,430 L230,360 L160,420 L180,330 L100,350 L140,270 L70,230 L150,200 L120,110 L200,150 Z"
                fill="url(#sunburst)"
                stroke="#ff5c5c"
                strokeWidth="8"
                strokeLinejoin="round"
              />

              <text
                x="250"
                y="260"
                className="free-text"
                transform="rotate(-10, 250, 250)"
              >
                {languageData.free}
              </text>
            </svg>
          </div>
        )}

                     {/*  <img
                        src={imageByType?.[rewardType]}
                        className={`pulse ${rewardType} `}
                        alt=""
                      /> */}

                      <div className="flex u-container-layout align-items-center justify-content-center">
                        <p className="u-text-3 p-10p text-center">
                          {reward?.packages?.map((pkg, pkgIndex) => (
                            <span
                              key={pkgIndex}
                              className="white font-700 service_time fs-17 text-math"
                            >
                              {pkg?.name}
                            </span>
                          ))}
                        </p>
                      </div>
                    </div>
                  )
                );
              })}
              {/*    {(rewardType === "free_product" || rewardType === "package") && (
                <div className="u-group-1">
                  <div class="pulse free_product">
                    <svg
                      viewBox="0 0 500 500"
                      xmlns="http://www.w3.org/2000/svg"
                      class="pulse"
                      width="52px"
                    >
                      <defs>
                        <radialGradient id="sunburst" cx="50%" cy="50%" r="50%">
                          <stop offset="0%" stop-color="#ffce44"></stop>
                          <stop offset="100%" stop-color="#ff911a"></stop>
                        </radialGradient>
                      </defs>

                      <path
                        d="M250,50 L280,120 L350,80 L340,160 L420,150 L380,220 L450,270 L370,300 L400,380 L320,350 L280,430 L230,360 L160,420 L180,330 L100,350 L140,270 L70,230 L150,200 L120,110 L200,150 Z"
                        fill="url(#sunburst)"
                        stroke="#ff5c5c"
                        stroke-width="8"
                        stroke-linejoin="round"
                      ></path>

                      <text
                        x="250"
                        y="260"
                        class="free-text"
                        transform="rotate(-10, 250, 250)"
                      >
                        {languageData.free}
                      </text>
                    </svg>
                  </div>
                  <img
                    src={imageByType[rewardType]}
                    className="pulse free_product hidden"
                    alt=""
                  />
                  <div className="flex u-container-layout align-items-center justify-content-center">
                    <p className="u-text-3">
                      <span className="white font-700 service_time">
                        {reward?.packages?.[0]?.name ?? ""}
                      </span>
                    </p>
                  </div>
                </div>
              )} */}
              {Array.isArray(service) ? (
                service.map((item, index) => (
                  <h4
                    key={index}
                    className="u-text-4 font-15 description_offer"
                  >
                    {item}
                  </h4>
                ))
              ) : (
                <h4 className="u-text-4 font-15 description_offer">
                  {service}
                </h4>
              )}
              {date_end && (
              <h4 class="u-text-4 font-15 font-300">
                {languageData.limit_date} <span>{date_end}</span>
              </h4>
            )}
              <button data-interaction="take_introductory_offer_modal"
                type="button"
                className="btn bg-accent1 text-white pulse introductoryOffer"
                onClick={handleTakeOffer}
              >
                {languageData.actions.button}
              </button>
              <button data-interaction="close_introductory_offer_modal"
                type="button"
                className="btn-no close-offer-btn"
                onClick={onClose}
              >
                {languageData.actions.cancel}
              </button>
            </div>
          </div>
        </div>
       
      </Modal>
      {/* Spinner Overlay */}
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default OfferModal;
